import React from 'react';
import { useSetState } from 'utils/functions.utils';
import './current_orders.component.scss';
import { Assets, PrimaryButton, SwiperComponent, StepperComponent } from '../../utils/imports.utils';

interface CurrentOrderProps {
    requestId?: any;
    quantity?: any;
    address?: any;
    totalAmount?: any;
}

const CurrentOrderComponent = (props: CurrentOrderProps) => {
    const { requestId, quantity, address, totalAmount } = props
    const params = {
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: (index, className) => {
                console.log('ddd', index, className)
                return '<span class="' + className + '"></span>';
            }
        },
    }
    return (
        <div className='current_order_card_container'>
            <div className='swiper_wrap'>
                <SwiperComponent params={params}>
                    <img src={Assets.sareeImage} className='saree_image' />
                    <img src={Assets.sareeImage} className='saree_image' />
                </SwiperComponent>
            </div>
            <div className='address_wrap'>
                <div className='request-id_quantity_wrap'>
                    <div className='request-id_wrap'>{requestId}
                    </div>
                    <div className='quantity_wrap'>Quantity : {quantity}</div>
                </div>
                <div style={{ padding: 5,marginTop:'10px' }}>
                    <StepperComponent status={'ff'} />
                </div>

            </div>
        </div>
    )
}

export default CurrentOrderComponent;
